import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  IconButton,
  Box,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  CircularProgress,
  Grid,
  TablePagination,
  Card,
  CardHeader,
  CardContent,
  Container,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title as ChartTitle,
  Tooltip as ChartTooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Navbar from "../../../../globals/components/Navbar";
import { apiClient } from "../../../../globals/utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import TablePaginationActions from "../../../../globals/components/TablePaginationActions";

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartTitle, ChartTooltip, Legend);

function CarrierProfile() {
  const [open, setOpen] = useState(false);
  const [openBondDialog, setOpenBondDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const {id} = useParams();
  
  const [carrier, setCarrier] = useState('');
  useEffect(()=>{setCarrier(localStorage.getItem("carrierName"))}, [])

  // Tabs
  const [tabValue, setTabValue] = useState(0);
  const [bondGraphData, setBondGraphData] = useState({ labels: [], datasets: [{ label: 'Bond History', backgroundColor: '#1976d2', data: [] }] });

  // Carrier details (view/edit)
  const [carrierDetails, setCarrierDetails] = useState({});
  const [isEditingCarrier, setIsEditingCarrier] = useState(false);
  const [isSavingCarrier, setIsSavingCarrier] = useState(false);

  const fetchCarrierDetails = async () => {
    try {
      const response = await apiClient(`/carriers/${id}`, 'GET');
      const data = response?.data ?? response;
      setCarrierDetails(data || {});
    } catch (err) {
      console.error('Failed to fetch carrier details', err);
    }
  };

  const handleSaveCarrier = async () => {
    try {
      setIsSavingCarrier(true);
      const payload = {
        name: carrierDetails.name || '',
        carrier_processing_email: carrierDetails.carrier_processing_email || '',
        agency_code: carrierDetails.agency_code || '',
      };
      await apiClient(`/carriers/${id}/`, 'PATCH', payload);
      toast.success('Carrier updated successfully');
      setIsEditingCarrier(false);
      fetchCarrierDetails();
    } catch (err) {
      toast.error('Failed to update carrier');
      console.error(err);
    } finally {
      setIsSavingCarrier(false);
    }
  };

  // Pagination: Team Members
  const [pageTeam, setPageTeam] = useState(0);
  const [rowsPerPageTeam, setRowsPerPageTeam] = useState(10);
  const handleChangePageTeam = (event, newPage) => setPageTeam(newPage);
  const handleChangeRowsPerPageTeam = (event) => { setRowsPerPageTeam(parseInt(event.target.value, 10)); setPageTeam(0); };

  // Pagination: Companies
  const [pageCompanies, setPageCompanies] = useState(0);
  const [rowsPerPageCompanies, setRowsPerPageCompanies] = useState(10);
  const handleChangePageCompanies = (event, newPage) => setPageCompanies(newPage);
  const handleChangeRowsPerPageCompanies = (event) => { setRowsPerPageCompanies(parseInt(event.target.value, 10)); setPageCompanies(0); };

  // Pagination: Commissions
  const [pageCommissions, setPageCommissions] = useState(0);
  const [rowsPerPageCommissions, setRowsPerPageCommissions] = useState(10);
  const handleChangePageCommissions = (event, newPage) => setPageCommissions(newPage);
  const handleChangeRowsPerPageCommissions = (event) => { setRowsPerPageCommissions(parseInt(event.target.value, 10)); setPageCommissions(0); };

  // Pagination: Limits
  const [pageLimits, setPageLimits] = useState(0);
  const [rowsPerPageLimits, setRowsPerPageLimits] = useState(10);
  const handleChangePageLimits = (event, newPage) => setPageLimits(newPage);
  const handleChangeRowsPerPageLimits = (event) => { setRowsPerPageLimits(parseInt(event.target.value, 10)); setPageLimits(0); };

  // Pagination: States
  const [pageStates, setPageStates] = useState(0);
  const [rowsPerPageStates, setRowsPerPageStates] = useState(10);
  const handleChangePageStates = (event, newPage) => setPageStates(newPage);
  const handleChangeRowsPerPageStates = (event) => { setRowsPerPageStates(parseInt(event.target.value, 10)); setPageStates(0); };

  // Pagination: Bonds
  const [pageBonds, setPageBonds] = useState(0);
  const [rowsPerPageBonds, setRowsPerPageBonds] = useState(10);
  const handleChangePageBonds = (event, newPage) => setPageBonds(newPage);
  const handleChangeRowsPerPageBonds = (event) => { setRowsPerPageBonds(parseInt(event.target.value, 10)); setPageBonds(0); };


  //Team Members
  const [teamMemberName, setTeamMemberName] = useState("");
  const [teamMemberEmail, setTeamMemberEmail] = useState("");
  const [teamMemberPhone, setTeamMemberPhone] = useState("");
  const [teamMemberPosition, setTeamMemberPosition] = useState("");
  const [teamMemberStatus, setTeamMemberStatus] = useState("");
  const [teamMemberPriority, setTeamMemberPriority] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sendInvite, setSendInvite] = useState(false);

  const positions = [
    "Underwriter",
    "Underwriting Assistant",
    "Manager",
    "Vice President",
    "Marketing Representative",
  ];

  const statuses = ["Available", "Unavailable"];
  const priorities = Array.from({ length: 10 }, (_, i) => i + 1);

  const [teamMembers, setTeamMembers] = useState([]);

  // Handle dialog open/close
  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  // Open the edit dialog
  const handleEditClick = (member) => {
    setSelectedMember(member);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedMember(null);
  };

   // Handle the update API call
   const handleUpdateMember = async () => {
    if (!selectedMember) return;
    const { team_member_id, ...updateData } = selectedMember;
    delete updateData.user;

    setIsSubmitting(true);
    try {
      await apiClient(`/carrier-team-member/${team_member_id}`, "PATCH", updateData);
      toast.success("Team member updated successfully!");
      handleCloseEditDialog();
      fetchTeamMembers(); // Refresh the list
    } catch (error) {
      toast.error("Failed to update team member.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle delete API call
  const handleDeleteMember = async (team_member_id) => {
    if (!window.confirm("Are you sure you want to delete this team member?")) return;

    setLoading(true);
    try {
      await apiClient(`/carrier-team-member/${team_member_id}`, "DELETE");
      toast.success("Team member deleted successfully!");
      fetchTeamMembers(); // Refresh the list
    } catch (error) {
      toast.error("Failed to delete team member.");
    } finally {
      setLoading(false);
    }
  };


  // Handle API Call
  const handleInvite = async () => {
      const requestData = {
        user: {
          email: teamMemberEmail,
        },
        team_member_name: teamMemberName,
        team_member_email: teamMemberEmail,
        team_member_position: teamMemberPosition,
        team_member_phonenumber: teamMemberPhone,
        team_member_carrier_id: id, 
        team_member_status: teamMemberStatus === "Available",
        team_member_priority: teamMemberPriority,
        send_invite: sendInvite,
      };
  
      setIsSubmitting(true);
      try {
        await apiClient("/invite-carrier-team-member", "POST", requestData);
        toast.success(
          sendInvite
            ? "Team member created and invite sent successfully!"
            : "Team member created successfully!"
        );
        fetchTeamMembers();
        handleCloseDialog();
      } catch (error) {
        toast.error(error?.detail || "Failed to invite team member.");
      } finally {
        setIsSubmitting(false);
      }
  };

  // Fetch team members from the API
  const fetchTeamMembers = async () => {
      setLoading(true);
      try {
        const response = await apiClient(`/team-members/${id}`);
        setTeamMembers(response);
      } catch (error) {
        // Error handling
      } finally {
        setLoading(false);
      }
  };


  //Companies
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(true)
  const [openEditCompanyDialog, setOpenEditCompanyDialog] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [editCompanyName, setEditCompanyName] = useState("");
  const [editCompanyNAIC, setEditCompanyNAIC] = useState("");
  const [editCompanyLoading, setEditCompanyLoading] = useState(false);
  const [deleteCompanyLoading, setDeleteCompanyLoading] = useState(false);
  const handleOpenCompanyDialog = () => setOpenCompanyDialog(true);
  const handleCloseCompanyDialog = () => setOpenCompanyDialog(false);

  const fetchCompanies = async () => {
    setCompaniesLoading(true);
    try {
      const response = await apiClient(`/carrier-companies/${id}`, 'GET', {}, {});
      setCompanies(response.data);
    } catch (error) {
      toast.error('Failed to load carrier companies.');
    } finally {
      setCompaniesLoading(false);
    }
  };

  const handleAddCompany = async () => {
    if (!companyName || !companyNAIC) {
      toast.error("Please fill out all fields.");
      return;
    }
  
    const requestData = {
      carrier_company_name: companyName,
      carrier_company_naic: companyNAIC,
      carrier_id: id, // Assuming `id` is the carrier ID from `useParams()`
    };
  
    setIsSubmitting(true);
    try {
      await apiClient("/companies/", "POST", requestData);
      toast.success("Company added successfully!");
      handleCloseCompanyDialog(); // Close the dialog
      fetchCompanies(); // Refresh the companies list
    } catch (error) {
      toast.error("Failed to add company. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleEditCompanyClick = async (carrier_company_id) => {
    setEditCompanyLoading(true);
    try {
      const response = await apiClient(`/companies/${carrier_company_id}`, "GET");
      setSelectedCompany(response.data);
      setEditCompanyName(response.data.carrier_company_name);
      setEditCompanyNAIC(response.data.carrier_company_naic);
      setEditCompanyLoading(false);
      setOpenEditCompanyDialog(true);
    } catch (error) {
      toast.error("Failed to fetch company details.");
    } finally {
      setEditCompanyLoading(false);
    }
  };

  const handleUpdateCompany = async () => {
    if (!selectedCompany) return;
  
    const updateData = {
      carrier_company_name: editCompanyName,
      carrier_company_naic: editCompanyNAIC,
    };
  
    setIsSubmitting(true);
    try {
      await apiClient(`/companies/${selectedCompany.carrier_company_id}/`, "PATCH", updateData);
      toast.success("Company updated successfully!");
      setOpenEditCompanyDialog(false);
      fetchCompanies(); // Refresh companies list
    } catch (error) {
      toast.error("Failed to update company.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteCompany = async (carrier_company_id) => {
    if (!window.confirm("Are you sure you want to delete this company?")) return;
    setDeleteCompanyLoading(true);
    setCompaniesLoading(true);
    try {
      await apiClient(`/companies/${carrier_company_id}`, "DELETE");
      toast.success("Company deleted successfully!");
      fetchCompanies(); // Refresh companies list
    } catch (error) {
      toast.error("Failed to delete company.");
    } finally {
      setDeleteCompanyLoading(false);
      setCompaniesLoading(false);
    }
  };

  //Commissions
  const [commissionBondType, setCommissionBondType] = useState("");
  const [commissionPercentage, setCommissionPercentage] = useState("");
  const [commissionEffectiveDate, setCommissionEffectiveDate] = useState("");
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false);
  const [isSubmittingCommission, setIsSubmittingCommission] = useState(false);
  const [commissionLoading, setCommissionLoading] = useState(true);
  const [commissionDetailLoading, setCommissionDetailsLoading] = useState(true);
  const [commissions, setCommissions] = useState([]);
  const [openUpdateCommissionDialog, setOpenUpdateCommissionDialog] = useState(false);
  const [commissionData, setCommissionData] = useState(null);
  const [selectedCommissionId, setSelectedCommissionId] = useState(null);

// Fields for updating commission
const [bondType, setBondType] = useState("");
const [commissionPercent, setCommissionPercent] = useState("");
const [effectiveDate, setEffectiveDate] = useState("");

  const fetchCommissions = async () => {
    setCommissionLoading(true);
    try {
      const response = await apiClient(`/commissions/by-carrier/?commission_carrier=${id}`, "GET");
      const sortedAlphabetically = response.sort((a, b) => {
        const nameA = a.bond_type_display.name.toUpperCase();
        const nameB = b.bond_type_display.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
    })
      setCommissions(sortedAlphabetically || []);
    } catch (error) {
      toast.error("Failed to load commissions.");
    } finally {
      setCommissionLoading(false);
    }
  };
  

  const handleAddCommission = async () => {
    if (!commissionBondType || !commissionPercentage || !commissionEffectiveDate) {
      toast.error("Please fill out all fields.");
      return;
    }
  
    const requestData = {
      bond_type: commissionBondType,
      commission_percent: parseInt(commissionPercentage, 10),
      effective_date: commissionEffectiveDate,
      commission_carrier: id, // Assuming `id` is the carrier ID from `useParams()`
      commission_carrier_id: id, // Assuming `id` is the carrier ID from `useParams()`
    };
  
    setIsSubmittingCommission(true);
    try {
      await apiClient("/commissions/", "POST", requestData);
      toast.success("Commission added successfully!");
      setOpenCommissionDialog(false); // Close the dialog
      fetchCommissions(); // Refresh the commissions list
    } catch (error) {
      toast.error("Failed to add commission. Please try again.");
    } finally {
      setIsSubmittingCommission(false);
    }
  };

  const handleOpenUpdateCommissionDialog = async (commissionId) => {
    setSelectedCommissionId(commissionId);
    setOpenUpdateCommissionDialog(true);
    fetchCommissionDetails(commissionId);
  };
  
  const fetchCommissionDetails = async (commissionId) => {
    setCommissionDetailsLoading(true);
    try {
      const response = await apiClient(`/commissions/${commissionId}/`, "GET");
      setCommissionData(response);
      setBondType(response.data.bond_type);
      setCommissionPercent(response.data.commission_percent);
      setEffectiveDate(response.data.effective_date);
    } catch (error) {
      toast.error("Failed to fetch commission details.");
    } finally {
      setCommissionDetailsLoading(false);
    }
  };

  const handleCloseUpdateCommissionDialog = () => {
    setOpenUpdateCommissionDialog(false);
    setSelectedCommissionId(null);
    setBondType("");
    setCommissionPercent("");
    setEffectiveDate("");
  };

  const handleUpdateCommission = async () => {
    setIsSubmitting(true);
    if (!selectedCommissionId) return;
    const updatedData = {
      commission_carrier_id: id,
      bond_type: bondType?bondType:commissionData.bond_type_display.id,
      commission_percent: commissionPercent?commissionPercent:commissionData.commission_percent,
      effective_date: effectiveDate?effectiveDate:commissionData.effective_date,
    };
  
    try {
      await apiClient(`/commissions/${selectedCommissionId}/`, "PATCH", updatedData);
      toast.success("Commission updated successfully!");
      handleCloseUpdateCommissionDialog();
      fetchCommissions(); // Refresh the commissions list
    } catch (error) {
      toast.error("Failed to update commission.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteCommission = async (commissionId) => {
    if (!window.confirm("Are you sure you want to delete this commission?")) return;
  
    try {
      await apiClient(`/commissions/${commissionId}/`, "DELETE");
      toast.success("Commission deleted successfully!");
      fetchCommissions(); // Refresh the commissions list
    } catch (error) {
      toast.error("Failed to delete commission.");
    }
  };

  //Limits
  const [carrierLimits, setCarrierLimits] = useState([]);

 // Carrier Info (License Info) CRUD
 const [licenseInfos, setLicenseInfos] = useState([]);
 const [licenseLoading, setLicenseLoading] = useState(true);
 const [openAddLicenseDialog, setOpenAddLicenseDialog] = useState(false);
 const [openEditLicenseDialog, setOpenEditLicenseDialog] = useState(false);
 const [isSubmittingLicense, setIsSubmittingLicense] = useState(false);
 const [newLicenseType, setNewLicenseType] = useState("");
 const [newLicenseValue, setNewLicenseValue] = useState("");
 const [selectedLicense, setSelectedLicense] = useState(null);

 const fetchLicenseInfos = async () => {
   setLicenseLoading(true);
   try {
     const response = await apiClient(`/license-info/by-carrier/${id}/`, "GET");
     const rows = Array.isArray(response) ? response : (response?.data || []);
     setLicenseInfos(rows || []);
   } catch (error) {
     toast.error("Failed to load carrier info.");
   } finally {
     setLicenseLoading(false);
   }
 };

 const handleAddLicenseInfo = async () => {
   if (!newLicenseType || !newLicenseValue) {
     toast.error("Please fill out all fields.");
     return;
   }
   setIsSubmittingLicense(true);
   try {
     await apiClient(`/license-info/`, "POST", {
       bond_carrier_id: Number(id),
       license_info_type: newLicenseType,
       license_info_value: newLicenseValue,
     });
     toast.success("Carrier info added successfully!");
     setOpenAddLicenseDialog(false);
     setNewLicenseType("");
     setNewLicenseValue("");
     fetchLicenseInfos();
   } catch (error) {
     toast.error("Failed to add carrier info.");
   } finally {
     setIsSubmittingLicense(false);
   }
 };

 const handleOpenEditLicense = (row) => {
   setSelectedLicense(row);
   setNewLicenseType(row.license_info_type || "");
   setNewLicenseValue(row.license_info_value || "");
   setOpenEditLicenseDialog(true);
 };

 const handleUpdateLicenseInfo = async () => {
   if (!selectedLicense) return;
   setIsSubmittingLicense(true);
   try {
     await apiClient(`/license-info/${selectedLicense.license_id}/`, "PATCH", {
       license_info_type: newLicenseType,
       license_info_value: newLicenseValue,
       bond_carrier_id: Number(id),
     });
     toast.success("Carrier info updated successfully!");
     setOpenEditLicenseDialog(false);
     setSelectedLicense(null);
     setNewLicenseType("");
     setNewLicenseValue("");
     fetchLicenseInfos();
   } catch (error) {
     toast.error("Failed to update carrier info.");
   } finally {
     setIsSubmittingLicense(false);
   }
 };

 const handleDeleteLicenseInfo = async (licenseId) => {
   if (!window.confirm("Are you sure you want to delete this carrier info?")) return;
   try {
     await apiClient(`/license-info/${licenseId}/`, "DELETE");
     toast.success("Carrier info deleted successfully!");
     fetchLicenseInfos();
   } catch (error) {
     toast.error("Failed to delete carrier info.");
   }
 };

const fetchCarrierLimits = async () => {
  try {
    const data = await apiClient(`/carrier-limits/${id}/`);
    const sortedAlphabetically = data.data.sort((a, b) => {
      const nameA = a.bond_type_display.type.toUpperCase();
      const nameB = b.bond_type_display.type.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;})
    setCarrierLimits(sortedAlphabetically || []); // Adjust to match API response format
  } catch (error) {
    console.error("Error fetching carrier limits:", error);
  }
};

const createCarrierLimit = async (limitData) => {
  try {
    const response = await apiClient("/limits/", "POST", limitData);
    return response;
  } catch (error) {
    console.error("Error creating limit:", error);
    throw error;
  }
};


const handleAddLimits = async () => {
  if (!limitBondType || !limitAuthorityLimit || !limitEffectiveDate) {
    toast.error("Please fill out all fields.");
    return;
  }

  const requestData = {
    bond_type: limitBondType,
    bond_amount: parseInt(limitAuthorityLimit, 10), // Ensure numeric input
    effective_date: limitEffectiveDate,
    limits_carrier: id, // Carrier ID from `useParams()`
  };

  setIsSubmitting(true);
  try {
    await createCarrierLimit(requestData);
    toast.success("Limit added successfully!");
    setOpenLimitDialog(false); // Close the dialog
    fetchCarrierLimits(); // Refresh the limits list
  } catch (error) {
    toast.error("Failed to add limit. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

const fetchLimitDetails = async (limitId) => {
  try {
    const response = await apiClient(`/limits/${limitId}/`, "GET");
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch limit details.");
    console.error("Error fetching limit details:", error);
    throw error;
  }
};

const [isEditLimitDialogOpen, setIsEditLimitDialogOpen] = useState(false);
const [editLimitDetails, setEditLimitDetails] = useState({
  bond_amount: "",
  effective_date: "",
  bond_type: "",
});
const [editingLimitId, setEditingLimitId] = useState(null);

const handleEditLimitClick = async (limitId) => {
  try {
    const limit = await fetchLimitDetails(limitId);
    setEditLimitDetails({
      bond_amount: limit.bond_amount,
      effective_date: limit.effective_date,
      bond_type: limit.bond_type,
    });
    setEditingLimitId(limitId);
    setIsEditLimitDialogOpen(true);
  } catch (error) {
    console.error("Failed to open edit dialog:", error);
  }
};


const handleUpdateLimit = async () => {
  if (!editingLimitId) return;

  const requestData = {
    bond_amount: editLimitDetails.bond_amount,
    effective_date: editLimitDetails.effective_date,
    bond_type: editLimitDetails.bond_type,
  };

  setIsSubmitting(true);
  try {
    await apiClient(`/limits/${editingLimitId}/`, "PATCH", requestData);
    toast.success("Limit updated successfully!");
    setIsEditLimitDialogOpen(false);
    fetchCarrierLimits(); // Refresh the list
  } catch (error) {
    toast.error("Failed to update limit.");
    console.error("Error updating limit:", error);
  } finally {
    setIsSubmitting(false);
  }
};


const handleDeleteLimit = async (limitId) => {
  if (!window.confirm("Are you sure you want to delete this limit?")) return;

  setIsSubmitting(true);
  try {
    await apiClient(`/limits/${limitId}/`, "DELETE");
    toast.success("Limit deleted successfully!");
    fetchCarrierLimits(); // Refresh the list
  } catch (error) {
    toast.error("Failed to delete limit.");
    console.error("Error deleting limit:", error);
  } finally {
    setIsSubmitting(false);
  }
};




  


  //Complete
  const [statesList, setStatesList] = useState([]);
  const [bondsList, setBondsList] = useState([]);
  const fetchBondTypesAndStates = async () => {
    setLoading(true);
    try {
      const response = await apiClient("/bondtypes/", "GET");
      const statesRes = await apiClient(`/states/0/`, "GET");
      setBondsList(response || []);
      setStatesList(Array.isArray(statesRes) ? statesRes : statesRes || []);
    } catch (error) {
      toast.error("Failed to load bond types.");
      console.error("Error fetching bond types:", error);
    } finally {
      setLoading(false);
    }
  };

  //Applicable States
  const [states, setStates] = useState([]);
  const fetchCarrierStates = async () => {
    setLoading(true);
    try {
      const response = await apiClient(`/carrier-states/${id}`, "GET"); // Update the endpoint if needed
      setStates(response.data || []); // Assuming the response contains the list of states
    } catch (error) {
      toast.error("Failed to fetch states.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddState = async () => {
    if (!stateName) {
      toast.error("Please select a state.");
      return;
    }
  
    const requestData = {
      bond_carrier_id: id, // Carrier ID from `useParams()`
      bond_state_id: stateName, // Selected state ID
    };
  
    setIsSubmitting(true);
    try {
      await apiClient("/carrier-states/", "POST", requestData);
      toast.success("State added successfully!");
      setOpenStateDialog(false);
      fetchCarrierStates(); // Refresh the states list
    } catch (error) {
      toast.error("Failed to add state.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const handleDeleteState = async (stateId) => {
    if (!window.confirm("Are you sure you want to delete this state?")) return;
  
    setLoading(true);
    try {
      await apiClient(`/carrier-states/${stateId}/`, "DELETE"); // Update endpoint if needed
      toast.success("State deleted successfully!");
      fetchCarrierStates(); // Refresh the states list
    } catch (error) {
      toast.error("Failed to delete state.");
    } finally {
      setLoading(false);
    }
  };
  
  //Applicanle Bonds
  const [bondsLoading, setBondsLoading] = useState(true);
  const fetchCarrierBonds = async () => {
    setBondsLoading(true);
    try {
      const response = await apiClient(`/carrier-bondtype-list/${id}/`, "GET"); // Update the endpoint if needed
      const sortedAlphabetically = response.data.sort((a, b) => {
        const nameA = a.bond_type.type.toUpperCase();
        const nameB = b.bond_type.type.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;})
      setBonds(sortedAlphabetically || []); // Assuming the response contains the list of states
    } catch (error) {
      toast.error("Failed to fetch bonds.");
    } finally {
      setBondsLoading(false);
    }
  };

  const handleAddBond = async () => {
    if (!bondName) {
      toast.error("Please select a state.");
      return;
    }
  
    const requestData = {
      bond_carrier: id, // Carrier ID from `useParams()`
      bond_carrier_id: id, // Carrier ID from `useParams()`
      bond_type: bondName, // Selected state ID
      bond_type_id: bondName, // Selected state ID
      code: bondCode,
    };
  
    setIsSubmitting(true);
    try {
      await apiClient("/carrier-bondtype/", "POST", requestData);
      toast.success("Bond added successfully!");
      setOpenBondDialog(false);
      fetchCarrierBonds(); // Refresh the states list
    } catch (error) {
      toast.error("Failed to add Bond.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [openEditBondDialog, setOpenEditBondDialog] = useState(false);
const [selectedBond, setSelectedBond] = useState(null);
const [updatedBondCode, setUpdatedBondCode] = useState("");

// Open Edit Bond Dialog
const handleEditBondClick = (bond) => {
  setSelectedBond(bond);
  setUpdatedBondCode(bond.code || "");
  setOpenEditBondDialog(true);
};

// Close Edit Bond Dialog
const handleCloseEditBondDialog = () => {
  setOpenEditBondDialog(false);
  setSelectedBond(null);
  setUpdatedBondCode("");
};

// Handle Bond Update API Call
const handleUpdateBond = async () => {
  if (!selectedBond) return;


  const updateData = {
    bond_type_id:selectedBond.bond_type.bond_type_id,
    bond_carrier_id: selectedBond.bond_carrier,
    code: updatedBondCode,
  };

  setIsSubmitting(true);
  try {
    await apiClient(`/carrier-bondtype/${selectedBond.bond_code_id}/`, "PATCH", updateData);
    toast.success("Bond updated successfully!");
    setOpenEditBondDialog(false);
    fetchCarrierBonds(); // Refresh the bonds list
  } catch (error) {
    toast.error("Failed to update bond.");
  } finally {
    setIsSubmitting(false);
  }
};

// Handle Bond Delete API Call
const handleDeleteBond = async (bondId) => {
  if (!window.confirm("Are you sure you want to delete this bond?")) return;

  setBondsLoading(true);
  try {
    await apiClient(`/carrier-bondtype/${bondId}/`, "DELETE");
    toast.success("Bond Type deleted successfully!");
    fetchCarrierBonds(); // Refresh the bonds list
  } catch (error) {
    toast.error("Failed to delete bond.");
  } finally {
    setBondsLoading(false);
  }
};



  

  useEffect(() => {
    fetchCarrierDetails();
    fetchBondTypesAndStates();
    fetchTeamMembers();
    fetchCompanies();
    fetchCommissions(); 
    fetchCarrierLimits();
    fetchCarrierStates();
    fetchCarrierBonds();
    fetchLicenseInfos();
    // fetch bond counts by year for graph
    (async () => {
      try {
        const rows = await apiClient(`/bonds/count-by-year/${id}/`, 'GET');
        const dataRows = Array.isArray(rows) ? rows : (rows?.data || []);
        const labels = dataRows.map(r => r.year);
        const data = dataRows.map(r => r.count);
        setBondGraphData({ labels, datasets: [{ label: 'Bond History', backgroundColor: '#1976d2', data }] });
      } catch (e) {
        setBondGraphData({ labels: [], datasets: [{ label: 'Bond History', backgroundColor: '#1976d2', data: [] }] });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const [bondName, setBondName] = useState("");
  const [bondCode, setBondCode] = useState("");
  const [bonds, setBonds] = useState([]);
  const [openStateDialog, setOpenStateDialog] = useState(false);
  const [stateName, setStateName] = useState("");

  // Handle dialog open/close
  const handleOpenStateDialog = () => setOpenStateDialog(true);
  const handleCloseStateDialog = () => setOpenStateDialog(false);

  const handleOpenBondDialog = () => setOpenBondDialog(true);
  const handleCloseBondDialog = () => setOpenBondDialog(false);

  // New state variables for company dialog and data
  const [openCompanyDialog, setOpenCompanyDialog] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyNAIC, setCompanyNAIC] = useState("");

  const handleDefaultChange = (naic) => {
    setCompanies((prevCompanies) =>
      prevCompanies.map((company) =>
        company.naic === naic ? { ...company, isDefault: !company.isDefault } : company
      )
     );
   };  

  // State variables for limits
  const [openLimitDialog, setOpenLimitDialog] = useState(false);
  const [limitBondType, setLimitBondType] = useState("");
  const [limitAuthorityLimit, setLimitAuthorityLimit] = useState("");
  const [limitEffectiveDate, setLimitEffectiveDate] = useState("");

  const handleOpenLimitDialog = () => setOpenLimitDialog(true);
  const handleCloseLimitDialog = () => setOpenLimitDialog(false);

  const formatDate = (date) => {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const formatAmount = (amount) => {
    if (amount === undefined || amount === null) return '';
    return new Intl.NumberFormat('en-US').format(amount);
  };

  // Common table styling to match rounded cards UI (same as StateDetails)
  const tableCardSx = {
    width: '100%',
    mb: 2,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  };
  const headerRowSx = { backgroundColor: '#f5f5f5', '& th': { fontWeight: 600 } };
  const paginationSx = {
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #e0e0e0',
    '& .MuiTablePagination-toolbar': { color: '#1976d2' },
    '& .MuiTablePagination-selectIcon': { color: '#1976d2' }
  };

  return (
    <>
      <Navbar/>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card elevation={3} sx={{ borderRadius: '16px', height: 'fit-content' }}>
              <CardHeader
                title={carrier ? `${carrier} - Carrier Details` : 'Carrier Details'}
                sx={{
                  backgroundColor: '#1976d2',
                  color: 'white',
                  '& .MuiCardHeader-title': { fontSize: '1.5rem', fontWeight: 600 }
                }}
                action={null}
              />
              <CardContent sx={{ padding: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Carrier Name"
                      name="name"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.name || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, name: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Processing Email"
                      name="carrier_processing_email"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.carrier_processing_email || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, carrier_processing_email: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Agency Code"
                      name="agency_code"
                      fullWidth
                      variant="outlined"
                      value={carrierDetails.agency_code || ''}
                      onChange={(e) => setCarrierDetails({ ...carrierDetails, agency_code: e.target.value })}
                      disabled={!isEditingCarrier}
                    />
                  </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  {isEditingCarrier ? (
                    <>
                      <Button variant="outlined" color="primary" onClick={() => setIsEditingCarrier(false)} sx={{ minWidth: 100 }}>
                        Cancel
                      </Button>
                      <Button variant="contained" color="primary" onClick={handleSaveCarrier} disabled={isSavingCarrier} sx={{ minWidth: 100 }}>
                        {isSavingCarrier ? <CircularProgress size={24} color="inherit" /> : 'Save'}
                      </Button>
                    </>
                  ) : (
                    <Button variant="contained" color="primary" onClick={() => setIsEditingCarrier(true)} sx={{ minWidth: 100 }}>
                      Edit
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={3} sx={{ borderRadius: '16px', height: 'fit-content' }}>
              <CardHeader
                title="Bond History"
                sx={{
                  backgroundColor: '#1565c0',
                  color: 'white',
                  '& .MuiCardHeader-title': { fontSize: '1.5rem', fontWeight: 600 }
                }}
              />
              <CardContent sx={{ padding: 3, marginBottom: 2 }}>
                {bondGraphData.labels.length === 0 ? (
                  <Typography variant="body2" color="text.secondary">No data</Typography>
                ) : (
                  <Bar
                    data={bondGraphData}
                    options={{
                      responsive: true,
                      plugins: { legend: { display: false }, title: { display: false } },
                      scales: { y: { ticks: { beginAtZero: true, precision: 0 } } }
                    }}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card elevation={3} sx={{ borderRadius: '16px' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={tabValue}
                  onChange={(e, v) => setTabValue(v)}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label={`Team Members (${teamMembers.length})`} />
                  <Tab label={`Companies (${companies.length})`} />
                  <Tab label={`Commissions (${commissions.length})`} />
                  <Tab label={`Limits (${carrierLimits.length})`} />
                  <Tab label={`States (${states.length})`} />
                  <Tab label={`Bonds (${bonds.length})`} />
                  <Tab label={`Carrier Info (${licenseInfos.length})`} />
                </Tabs>
              </Box>
              <CardContent sx={{ padding: 3 }}>

        {/* Team Members Tab */}
        <Box sx={{ display: tabValue === 0 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenDialog}
            >
              Add Team Member
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Team Member Name</TableCell>
                  <TableCell align="right">Email</TableCell>
                  <TableCell align="right">Position</TableCell>
                  <TableCell align="right">Phone Number</TableCell>
                  <TableCell align="right">Status</TableCell>
                  <TableCell align="right">Priority</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100px",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : teamMembers.length > 0 ? (
                  teamMembers
                    .slice(pageTeam * rowsPerPageTeam, pageTeam * rowsPerPageTeam + rowsPerPageTeam)
                    .map((member, index) => (
                    <TableRow key={index}>
                      <TableCell>{member.team_member_name}</TableCell>
                      <TableCell align="right">{member.team_member_email}</TableCell>
                      <TableCell align="right">{member.team_member_position}</TableCell>
                      <TableCell align="right">{member.team_member_phonenumber}</TableCell>
                      <TableCell align="right">{member.team_member_status ? "Available" : "Unavailable"}</TableCell>
                      <TableCell align="right">{member.team_member_priority}</TableCell>
                      <TableCell align="right">
                        <IconButton color="primary" onClick={() => handleEditClick(member)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDeleteMember(member.team_member_id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No team members found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={teamMembers.length}
            page={pageTeam}
            onPageChange={handleChangePageTeam}
            rowsPerPage={rowsPerPageTeam}
            onRowsPerPageChange={handleChangeRowsPerPageTeam}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* Companies Tab */}
        <Box sx={{ display: tabValue === 1 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenCompanyDialog}
            >
              Add Company
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Company Name</TableCell>
                  <TableCell align="right">NAIC</TableCell>
                  <TableCell align="right">Default</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companiesLoading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100px",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : companies.length > 0 ? (
                  companies
                    .slice(pageCompanies * rowsPerPageCompanies, pageCompanies * rowsPerPageCompanies + rowsPerPageCompanies)
                    .map((company, index) => (
                    <TableRow key={index}>
                      <TableCell>{company.carrier_company_name}</TableCell>
                      <TableCell align="right">{company.carrier_company_naic}</TableCell>
                      <TableCell align="right">
                        <Checkbox
                          checked={company.isDefault}
                          onChange={() => handleDefaultChange(company.carrier_company_naic)}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          color="primary"
                          onClick={() => handleEditCompanyClick(company.carrier_company_id)}
                          disabled={editCompanyLoading || deleteCompanyLoading}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteCompany(company.carrier_company_id)}
                          disabled={editCompanyLoading || deleteCompanyLoading}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No companies found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={companies.length}
            page={pageCompanies}
            onPageChange={handleChangePageCompanies}
            rowsPerPage={rowsPerPageCompanies}
            onRowsPerPageChange={handleChangeRowsPerPageCompanies}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* Commissions Tab */}
        <Box sx={{ display: tabValue === 2 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setOpenCommissionDialog(true)}
            >
              Add Commission
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Bond Type</TableCell>
                  <TableCell align="right">Percentage</TableCell>
                  <TableCell align="right">Effective Date</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {commissionLoading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : commissions.length > 0 ? (
                  commissions
                    .slice(pageCommissions * rowsPerPageCommissions, pageCommissions * rowsPerPageCommissions + rowsPerPageCommissions)
                    .map((commission, index) => (
                    <TableRow key={index}>
                      <TableCell>{commission.bond_type_display.name}</TableCell>
                      <TableCell align="right">{commission.commission_percent}%</TableCell>
                      <TableCell align="right">{formatDate(commission.effective_date)}</TableCell>
                      <TableCell align="center">
                        <IconButton color="primary" onClick={() => handleOpenUpdateCommissionDialog(commission.commission_id)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDeleteCommission(commission.commission_id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No commissions found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={commissions.length}
            page={pageCommissions}
            onPageChange={handleChangePageCommissions}
            rowsPerPage={rowsPerPageCommissions}
            onRowsPerPageChange={handleChangeRowsPerPageCommissions}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* Limits Tab */}
        <Box sx={{ display: tabValue === 3 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenLimitDialog}
            >
              Add Limit
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Bond Type</TableCell>
                  <TableCell align="right">Authority Limit</TableCell>
                  <TableCell align="right">Effective Date</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {carrierLimits.length > 0 ? (
                  carrierLimits
                    .slice(pageLimits * rowsPerPageLimits, pageLimits * rowsPerPageLimits + rowsPerPageLimits)
                    .map((limit, index) => (
                    <TableRow key={index}>
                      <TableCell>{limit.bond_type_display?.type || "N/A"}</TableCell>
                      <TableCell align="right">${formatAmount(limit.bond_amount)}</TableCell>
                      <TableCell align="right">{formatDate(limit.effective_date)}</TableCell>
                      <TableCell align="center">
                        <IconButton color="primary" onClick={() => handleEditLimitClick(limit.limit_id)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDeleteLimit(limit.limit_id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No limits found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={carrierLimits.length}
            page={pageLimits}
            onPageChange={handleChangePageLimits}
            rowsPerPage={rowsPerPageLimits}
            onRowsPerPageChange={handleChangeRowsPerPageLimits}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* States Tab */}
        <Box sx={{ display: tabValue === 4 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenStateDialog}
            >
              Add State
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>State Name</TableCell>
                  <TableCell align="right">State Code</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : states.length > 0 ? (
                  states
                    .slice(pageStates * rowsPerPageStates, pageStates * rowsPerPageStates + rowsPerPageStates)
                    .map((state, index) => (
                    <TableRow key={index}>
                      <TableCell>{state.bond_state.state_name}</TableCell>
                      <TableCell align="right">{state.bond_state.state_code}</TableCell>
                      <TableCell align="center">
                        <IconButton color="error" onClick={() => handleDeleteState(state.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No states found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={states.length}
            page={pageStates}
            onPageChange={handleChangePageStates}
            rowsPerPage={rowsPerPageStates}
            onRowsPerPageChange={handleChangeRowsPerPageStates}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* Bonds Tab */}
        <Box sx={{ display: tabValue === 5 ? 'block' : 'none' }}>
          

          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenBondDialog}
            >
              Add Bond
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Bond Name</TableCell>
                  <TableCell align="right">Running Total</TableCell>
                  <TableCell align="right">Bond Code</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bondsLoading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : bonds.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No bonds found
                    </TableCell>
                  </TableRow>
                ) : (
                  bonds
                    .slice(pageBonds * rowsPerPageBonds, pageBonds * rowsPerPageBonds + rowsPerPageBonds)
                    .map((bond, index) => (
                    <TableRow key={index}>
                      <TableCell>{bond.bond_type.type}</TableCell>
                      <TableCell align="right">{bond.total || 0}</TableCell>
                      <TableCell align="right">{bond.code}</TableCell>
                      <TableCell align="center">
                        <IconButton color="primary" onClick={() => handleEditBondClick(bond)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDeleteBond(bond.bond_code_id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
          ActionsComponent={TablePaginationActions}
            component="div"
            count={bonds.length}
            page={pageBonds}
            onPageChange={handleChangePageBonds}
            rowsPerPage={rowsPerPageBonds}
            onRowsPerPageChange={handleChangeRowsPerPageBonds}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={paginationSx}
          />
        </Box>

        {/* Carrier Info Tab */}
        <Box sx={{ display: tabValue === 6 ? 'block' : 'none' }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setOpenAddLicenseDialog(true)}
            >
              Add Carrier Info
            </Button>
          </Box>

          <TableContainer component={Paper} sx={tableCardSx}>
            <Table>
              <TableHead>
                <TableRow sx={headerRowSx}>
                  <TableCell>Type</TableCell>
                  <TableCell>Value</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {licenseLoading ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : licenseInfos.length > 0 ? (
                  licenseInfos.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.license_info_type || ""}</TableCell>
                      <TableCell>{row.license_info_value || ""}</TableCell>
                      <TableCell align="right">
                        <IconButton color="primary" onClick={() => handleOpenEditLicense(row)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDeleteLicenseInfo(row.license_id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No carrier info found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Dialog for Adding Team Member */}
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Add New Team Member</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={teamMemberName}
            onChange={(e) => setTeamMemberName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={teamMemberEmail}
            onChange={(e) => setTeamMemberEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Phone Number"
            type="text"
            fullWidth
            variant="outlined"
            value={teamMemberPhone}
            onChange={(e) => setTeamMemberPhone(e.target.value)}
          />
          <TextField
            select
            margin="dense"
            label="Position"
            fullWidth
            variant="outlined"
            value={teamMemberPosition}
            onChange={(e) => setTeamMemberPosition(e.target.value)}
          >
            {positions.map((position) => (
              <MenuItem key={position} value={position}>
                {position}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Status"
            fullWidth
            variant="outlined"
            value={teamMemberStatus}
            onChange={(e) => setTeamMemberStatus(e.target.value)}
          >
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Priority"
            fullWidth
            variant="outlined"
            value={teamMemberPriority}
            onChange={(e) => setTeamMemberPriority(e.target.value)}
          >
            {priorities.map((priority) => (
              <MenuItem key={priority} value={priority}>
                {priority}
              </MenuItem>
            ))}
          </TextField>
          <FormControlLabel
            control={
              <Checkbox
                checked={sendInvite}
                onChange={(e) => setSendInvite(e.target.checked)}
              />
            }
            label="Send Invite Email"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleInvite}
            color="primary"
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Add Team Member"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Team Member Dialog */}
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <DialogTitle>Edit Team Member</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_name || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_name: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_email || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_email: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label="Phone Number"
            type="text"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_phonenumber || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_phonenumber: e.target.value }))
            }
          />
          <TextField
            select
            margin="dense"
            label="Position"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_position || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_position: e.target.value }))
            }
          >
            {positions.map((position) => (
              <MenuItem key={position} value={position}>
                {position}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Status"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_status ? "Available" : "Unavailable"}
            onChange={(e) =>
              setSelectedMember((prev) => ({
                ...prev,
                team_member_status: e.target.value === "Available",
              }))
            }
          >
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Priority"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_priority || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_priority: e.target.value }))
            }
          >
            {priorities.map((priority) => (
              <MenuItem key={priority} value={priority}>
                {priority}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateMember}
            color="primary"
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Adding State */}
      <Dialog open={openStateDialog} onClose={handleCloseStateDialog}>
        <DialogTitle>Add New State</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          {/* State Name dropdown */}
          <TextField
            select
            margin="dense"
            label="State Name"
            fullWidth
            variant="outlined"
            value={stateName}
            onChange={(e) => setStateName(e.target.value)}
          >
            {statesList.map((option) => (
              <MenuItem key={option.bond_state_id} value={option.bond_state_id}>
                {option.state_name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseStateDialog} color="primary">
            Cancel
          </Button>
          <Button
  onClick={handleAddState}
  color="primary"
  variant="contained"
  disabled={isSubmitting}
>
  {isSubmitting ? <CircularProgress size={24} /> : "Add State"}
</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openBondDialog} onClose={handleCloseBondDialog}>
        <DialogTitle>Add New Bond</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          {/* Bond Name dropdown */}
          <TextField
            select
            margin="dense"
            label="Bond Name"
            fullWidth
            variant="outlined"
            value={bondName}
            onChange={(e) => setBondName(e.target.value)}
          >
            {bondsList.map((option) => (
        <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
          {option.type}
        </MenuItem>
      ))}
          </TextField>

          {/* Bond Code TextField */}
          <TextField
            margin="dense"
            label="Bond Code"
            type="text"
            fullWidth
            variant="outlined"
            value={bondCode}
            onChange={(e) => setBondCode(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBondDialog} color="primary">
            Cancel
          </Button>
          <Button
  onClick={handleAddBond}
  color="primary"
  variant="contained"
  disabled={isSubmitting}
>
  {isSubmitting ? <CircularProgress size={24} /> : "Add Bond"}
</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Adding Company */}
      <Dialog open={openCompanyDialog} onClose={handleCloseCompanyDialog}>
  <DialogTitle>Add New Company</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    <TextField
      autoFocus
      margin="dense"
      label="Company Name"
      type="text"
      fullWidth
      variant="outlined"
      value={companyName}
      onChange={(e) => setCompanyName(e.target.value)}
    />
    <TextField
      margin="dense"
      label="NAIC"
      type="text"
      fullWidth
      variant="outlined"
      value={companyNAIC}
      onChange={(e) => setCompanyNAIC(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseCompanyDialog} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleAddCompany}
      color="primary"
      variant="contained"
      disabled={isSubmitting}
    >
      {isSubmitting ? <CircularProgress size={24} /> : "Add Company"}
    </Button>
  </DialogActions>
</Dialog>

{/* Dialog for Editing a Company */}
<Dialog open={openEditCompanyDialog} onClose={() => setOpenEditCompanyDialog(false)}>
  <DialogTitle>Edit Company</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    <TextField
      autoFocus
      margin="dense"
      label="Company Name"
      type="text"
      fullWidth
      variant="outlined"
      value={editCompanyName}
      onChange={(e) => setEditCompanyName(e.target.value)}
    />
    <TextField
      margin="dense"
      label="NAIC"
      type="text"
      fullWidth
      variant="outlined"
      value={editCompanyNAIC}
      onChange={(e) => setEditCompanyNAIC(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenEditCompanyDialog(false)} color="primary">
      Cancel
    </Button>
    <Button onClick={handleUpdateCompany} color="primary" variant="contained" disabled={isSubmitting}>
      {isSubmitting ? <CircularProgress size={24} /> : "Save"}
    </Button>
  </DialogActions>
</Dialog>

      {/* Dialog for Adding Carrier Info */}
      <Dialog open={openAddLicenseDialog} onClose={() => setOpenAddLicenseDialog(false)}>
        <DialogTitle>Add Carrier Info</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Type"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseType}
            onChange={(e) => setNewLicenseType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Value"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseValue}
            onChange={(e) => setNewLicenseValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddLicenseDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddLicenseInfo} color="primary" variant="contained" disabled={isSubmittingLicense}>
            {isSubmittingLicense ? <CircularProgress size={24} /> : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Editing Carrier Info */}
      <Dialog open={openEditLicenseDialog} onClose={() => setOpenEditLicenseDialog(false)}>
        <DialogTitle>Edit Carrier Info</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            margin="dense"
            label="Type"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseType}
            onChange={(e) => setNewLicenseType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Value"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseValue}
            onChange={(e) => setNewLicenseValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditLicenseDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUpdateLicenseInfo} color="primary" variant="contained" disabled={isSubmittingLicense}>
            {isSubmittingLicense ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

{/* Dialog for Adding Commission */}
<Dialog open={openCommissionDialog} onClose={() => setOpenCommissionDialog(false)}>
  <DialogTitle>Add New Commission</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    <TextField
      select
      margin="dense"
      label="Bond Type"
      fullWidth
      variant="outlined"
      value={commissionBondType}
      onChange={(e) => setCommissionBondType(e.target.value)}
    >
      {bondsList.map((option) => (
        <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
          {option.type}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      margin="dense"
      label="Percentage"
      type="number"
      fullWidth
      variant="outlined"
      value={commissionPercentage}
      onChange={(e) => setCommissionPercentage(e.target.value)}
    />
    <TextField
      margin="dense"
      label="Effective Date"
      type="date"
      fullWidth
      variant="outlined"
      value={commissionEffectiveDate}
      onChange={(e) => setCommissionEffectiveDate(e.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenCommissionDialog(false)} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleAddCommission}
      color="primary"
      variant="contained"
      disabled={isSubmittingCommission}
    >
      {isSubmittingCommission ? <CircularProgress size={24} /> : "Add Commission"}
    </Button>
  </DialogActions>
</Dialog>

{/* Dialog for Updating Commission */}
<Dialog open={openUpdateCommissionDialog} onClose={handleCloseUpdateCommissionDialog}>
  <DialogTitle>Update Commission</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    {commissionDetailLoading ? (
      <CircularProgress />
    ) : (
      <>
        <TextField
          select
          margin="dense"
          label="Bond Type"
          fullWidth
          variant="outlined"
          value={bondType || commissionData.bond_type_display.id} // Use bondType state or fallback
          onChange={(e) => setBondType(e.target.value)}
        >
          {bondsList.map((option) => (
            <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
              {option.type || option.name} {/* Ensure the display text matches */}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          margin="dense"
          label="Commission Percentage"
          type="number" // Ensure numeric input
          fullWidth
          variant="outlined"
          value={commissionPercent !== null ? commissionPercent : commissionData.commission_percent} // Use local state or fallback
          onChange={(e) => {
            const value = e.target.value;
            // Allow empty input or valid numeric values
            if (value === '' || (!isNaN(value) && Number(value) >= 0)) {
              setCommissionPercent(value);
            }
          }}
          InputProps={{
            inputProps: { min: 0 }, // Ensure only positive numbers
          }}
        />
        <TextField
          margin="dense"
          label="Effective Date"
          type="date"
          fullWidth
          variant="outlined"
          value={effectiveDate || commissionData.effective_date} // Use local state or fallback
          onChange={(e) => setEffectiveDate(e.target.value)}
          InputLabelProps={{
            shrink: true, // Ensure the label shrinks for date type
          }}
        />
      </>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseUpdateCommissionDialog} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleUpdateCommission}
      color="primary"
      variant="contained"
      disabled={isSubmitting} // Disable the button when isSubmitting is true
      startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null} // Show progress icon if submitting
    >
      Save
    </Button>
  </DialogActions>
</Dialog>



{/* Dialog for Adding Limit */}
<Dialog open={openLimitDialog} onClose={handleCloseLimitDialog}>
  <DialogTitle>Add New Limit</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    <TextField
      select
      margin="dense"
      label="Bond Type"
      fullWidth
      variant="outlined"
      value={limitBondType}
      onChange={(e) => setLimitBondType(e.target.value)}
    >
      {bondsList.map((option) => (
        <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
          {option.type}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      margin="dense"
      label="Authority Limit"
      type="number"
      fullWidth
      variant="outlined"
      value={limitAuthorityLimit}
      onChange={(e) => setLimitAuthorityLimit(e.target.value)}
    />
    <TextField
      margin="dense"
      label="Effective Date"
      type="date"
      fullWidth
      variant="outlined"
      value={limitEffectiveDate}
      onChange={(e) => setLimitEffectiveDate(e.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseLimitDialog} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleAddLimits}
      color="primary"
      variant="contained"
      disabled={isSubmitting}
    >
      {isSubmitting ? <CircularProgress size={24} /> : "Add Limit"}
    </Button>
  </DialogActions>
</Dialog>

{/* Dialog for Updating Limit */}
<Dialog open={isEditLimitDialogOpen} onClose={() => setIsEditLimitDialogOpen(false)}>
  <DialogTitle>Edit Limit</DialogTitle>
  <DialogContent sx={{ width: "400px" }}>
    <TextField
      select
      margin="dense"
      label="Bond Type"
      fullWidth
      variant="outlined"
      value={editLimitDetails.bond_type}
      onChange={(e) => setEditLimitDetails({ ...editLimitDetails, bond_type: e.target.value })}
    >
      {bondsList.map((option) => (
        <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
          {option.type}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      margin="dense"
      label="Authority Limit"
      type="number"
      fullWidth
      variant="outlined"
      value={editLimitDetails.bond_amount}
      onChange={(e) => setEditLimitDetails({ ...editLimitDetails, bond_amount: e.target.value })}
    />
    <TextField
      margin="dense"
      label="Effective Date"
      type="date"
      fullWidth
      variant="outlined"
      value={editLimitDetails.effective_date}
      onChange={(e) => setEditLimitDetails({ ...editLimitDetails, effective_date: e.target.value })}
      InputLabelProps={{
        shrink: true,
      }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setIsEditLimitDialogOpen(false)} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleUpdateLimit}
      color="primary"
      variant="contained"
      disabled={isSubmitting}
    >
      {isSubmitting ? <CircularProgress size={24} /> : "Save"}
    </Button>
  </DialogActions>
</Dialog>

{/* Dialog for Updating Code */}
<Dialog open={openEditBondDialog} onClose={handleCloseEditBondDialog}>
  <DialogTitle>Edit Bond Code</DialogTitle>
  <DialogContent>
    <TextField
      margin="dense"
      label="Bond Code"
      type="text"
      fullWidth
      variant="outlined"
      value={updatedBondCode}
      onChange={(e) => setUpdatedBondCode(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseEditBondDialog} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleUpdateBond}
      color="primary"
      variant="contained"
      disabled={isSubmitting}
    >
      {isSubmitting ? <CircularProgress size={24} /> : "Save"}
    </Button>
  </DialogActions>
</Dialog>

    </>
  );
}

export default CarrierProfile;
